import getHostVariables from '../utils/getHostVariables';
import {PROPERTY_DEFS} from '../symbols';

export default function isSelectableProperty(componentRegistry, id, name) {
	const el = componentRegistry[id];
	const hostVariables = getHostVariables(el);
	if (el) {
		const propertyDefs = hostVariables[PROPERTY_DEFS];

		return (propertyDefs[name] && propertyDefs[name].selectable) || false;
	}

	return false;
}
